import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FolderI, FolderSelectionI } from '../../models/folder';
import { ProjectSelectorSelectionI } from '../folder-picker/project-selector/project-selector.component';

export enum PublicationSaveTypeE {
    DOCUMENT = 'DOCUMENT',
    BOOK = 'BOOK',
    WHOLE_BOOK = 'WHOLE_BOOK'
}

export enum FolderSortFieldE {
    NAME = 'name',
    CREATED_AT = 'createdAt'
}

export type SortDirectionT = 'asc' | 'desc';

export enum FolderPickerTabE {
    MY_PROJECTS = 'MY_PROJECTS',
    SHARED_WITH_ME = 'SHARED_WITH_ME'
}

@Component({
    selector: 'app-publication-save-in-folder-dialog',
    templateUrl: './publication-save-in-folder-dialog.component.html',
    styleUrls: ['./publication-save-in-folder-dialog.component.scss']
})
export class PublicationSaveInFolderDialogComponent {
    readonly FolderPickerTabE = FolderPickerTabE;

    @Input() title = 'document.detail.store.title';
    @Input() publicationId?: number;
    @Input() publicationType: PublicationSaveTypeE = PublicationSaveTypeE.DOCUMENT;
    @Input() disabled = false;
    // The parent knows the up-to-date state of the publication (eg. a book's current bookParts,
    // or a document's current version) and is the only one able to tell whether a folder that
    // already contains the publication is holding a stale copy of it.
    @Input() isFolderOutdated?: (folder: FolderI) => boolean;
    @Input() updateOutdatedFolder?: (folder: FolderI) => Promise<void>;

    @Output() save = new EventEmitter<FolderSelectionI>();
    @Output() cancel = new EventEmitter<void>();

    activeTab = FolderPickerTabE.MY_PROJECTS;

    selectedProjectId?: number;
    selectedFolderId?: number;

    get isFormValid(): boolean {
        return !!this.selectedFolderId || !!this.selectedProjectId;
    }

    onTabChange(tab: FolderPickerTabE): void {
        this.activeTab = tab;
    }

    onSelectionChange(selection: ProjectSelectorSelectionI): void {
        this.selectedProjectId = selection.projectId;
        this.selectedFolderId = selection.folderId;
    }

    onSubmit(): void {
        if (!this.isFormValid || this.disabled) {
            return;
        }
        this.save.emit(
            this.selectedFolderId ? { folderId: this.selectedFolderId } : { projectId: this.selectedProjectId }
        );
    }

    onCancel(): void {
        this.cancel.emit();
    }
}
